<template>
  <div class="lab-settings">
    <b-container fluid>
      <b-row>

        <!-- LEFT TAB LIST -->
        <b-col md="2" class="pr-0">
          <b-list-group>
            <b-list-group-item
              v-for="(tab, index) in labSettingTabs"
              :key="index"
              :active="currentTab === index"
              @click="loadTab(tab, index)"
            >
              {{ index + 1 }}) {{ tab.name }}
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <!-- RIGHT CONTENT -->
        <b-col md="10" class="pl-0">
          <component
            v-if="currentComponent"
            :is="currentComponent"
            :course_id="course_id"
            :roles="selectedTab.roles || []"
            :methodId="selectedTab.methodId || null"
            @methods-updated="fetchProjectMethods"
          />
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>

<script>
import MethodsAndParameters from "./MethodsAndParameters.vue";
import ProjectTypeTab from "./ProjectTypeTab.vue";
import axios from "axios";

export default {
  name: "ProjectDashboardNew",

  props: {
    course_id: {
      type: [Number, String],
      required: true
    },
    role_by: {
      type: String
    }
  },

  components: {
    MethodsAndParameters,
    ProjectTypeTab
  },

  data() {
    return {
      currentTab: 0,
      currentComponent: null,
      evaluationMethods: [],
      selectedTab: null
    };
  },

  created() {
    this.fetchProjectMethods();
  },

  computed: {
    defaultInstitutionUserId() {
      return this.$store.getters.getDefaultInstituteUserId;
    },

    labSettingTabs() {
      const tabs = [];

      if (this.role_by !== "projectFaculty") {
        tabs.push({
          name: "Evaluation Types & Parameters",
          component: "MethodsAndParameters"
        });
      }

      this.evaluationMethods.forEach(method => {
        const accessibleRoles = (method.roles || []).filter(role =>
          (role.faculties || []).some(
            faculty => faculty.id === this.defaultInstitutionUserId
          )
        );

        if (accessibleRoles.length > 0) {
          tabs.push({
            name: method.name,
            component: "ProjectTypeTab",
            roles: accessibleRoles,
            methodId: method.id
          });
        }
      });

      return tabs;
    }
  },

  watch: {
    labSettingTabs: {
      immediate: true,
      handler(tabs) {
        if (!tabs.length) return;

        if (!this.currentComponent) {
          this.currentTab = 0;
          this.currentComponent = tabs[0].component;
          this.selectedTab = tabs[0];
        }
      }
    }
  },

  methods: {
    loadTab(tab, index) {
      if (
        this.role_by === "projectFaculty" &&
        tab.component === "MethodsAndParameters"
      ) {
        return;
      }

      this.currentTab = index;
      this.currentComponent = tab.component;
      this.selectedTab = tab;
    },

    async fetchProjectMethods() {
      const url = `${this.$store.getters.getAPIKey.mainAPI}/projectmethods?course_id=${this.course_id}`;

      try {
        const response = await axios.get(url);

        this.evaluationMethods = response.data.map(method => ({
          id: method.id,
          name: method.name,
          roles: method.roles || [],
          parameters: method.project_parameters ?? []
        }));

        this.currentComponent = null;
        this.selectedTab = null;
        this.currentTab = 0;
      } catch (error) {
        this.$toast.error("Failed to fetch evaluation methods", {
          position: "top",
          duration: 3000
        });
      }
    }
  }
};
</script>


